"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyPreferencesRequirement = void 0;
const student_data_requirement_1 = require("./student-data-requirement");
const studentdomain_1 = require("@studyportals/studentdomain");
const scholarship_requirement_type_1 = require("../types/scholarship-requirement-type");
class StudyPreferencesRequirement extends student_data_requirement_1.StudentDataRequirement {
    constructor() {
        super(...arguments);
        this.type = scholarship_requirement_type_1.ScholarshipRequirementType.STUDY_PREFERENCES;
    }
    getRequiredStudentFields() {
        return [
            studentdomain_1.StudentField.INTERESTS_DISCIPLINES,
            studentdomain_1.StudentField.INTERESTS_COUNTRIES,
            studentdomain_1.StudentField.NATIONALITY_COUNTRY_ISO,
            studentdomain_1.StudentField.START_PERIOD_DATE,
            studentdomain_1.StudentField.ATTENDANCE,
        ];
    }
}
exports.StudyPreferencesRequirement = StudyPreferencesRequirement;
